function updateWebsocketData(data) {
  return {
    type: 'WS_EVENT',
    data,
  };
}

export {updateWebsocketData};
